import {contactFormCommonFields} from "@ignitesales/neuro-application";

const getFormFields = (isBranchGuide, isBusinessGuide, showCustomerId) => {
    const dialogueConsumerFields = [
        contactFormCommonFields.firstName,
        contactFormCommonFields.lastName,
        contactFormCommonFields.emailAddress,
        contactFormCommonFields.phoneNumber
    ];
    if(isBranchGuide && showCustomerId) {
        dialogueConsumerFields.push(contactFormCommonFields.customerId);
    }
    if(isBusinessGuide) {
        dialogueConsumerFields.push(contactFormCommonFields.businessName);
    }

    return dialogueConsumerFields;
};

export default getFormFields;
